// @moods/ui copy for the emoji picker, the lightbox and the composer upload tray. tr and en must have identical keys.
// Turkish part; media.en.ts must have the same keys.
const dict: Record<string, string> = {
  'emoji.label': 'Emoji seçici',
  'emoji.tabs': 'Seçici sekmeleri',
  'emoji.tab.emoji': 'Emoji',
  'emoji.tab.gif': 'GIF',
  'emoji.search': 'Emoji ara',
  'emoji.results': 'Arama sonuçları',
  'emoji.recent': 'Son kullanılanlar',
  'emoji.favorites': 'Favoriler',
  'emoji.categories': 'Emoji kategorileri',
  'emoji.empty': 'Emoji bulunamadı',
  'emoji.emptyHint': 'Başka bir kelime dene.',
  'emoji.loading': 'Emojiler yükleniyor',
  'emoji.locked': 'Bu emojiyi burada kullanamazsın.',
  'emoji.hint': 'Shift ile tıklarsan seçici açık kalır.',
  'emoji.favorite.add': 'Sağ tık: favorilere ekle',
  'emoji.favorite.remove': 'Sağ tık: favorilerden çıkar',
  'emoji.skin': 'Ten rengi',
  'emoji.skin.0': 'Varsayılan',
  'emoji.skin.1': 'Açık ten',
  'emoji.skin.2': 'Orta açık ten',
  'emoji.skin.3': 'Orta ten',
  'emoji.skin.4': 'Orta koyu ten',
  'emoji.skin.5': 'Koyu ten',
  'lightbox.label': 'Medya görüntüleyici',
  'lightbox.close': 'Kapat',
  'lightbox.prev': 'Önceki',
  'lightbox.next': 'Sonraki',
  'lightbox.zoomIn': 'Yakınlaştır',
  'lightbox.zoomOut': 'Uzaklaştır',
  'lightbox.download': 'İndir',
  'lightbox.open': 'Orijinali aç',
  'lightbox.position': '{index} / {count}',
  'lightbox.jump': 'Mesaja git',
  'chat.composer.spoilerOn': '{name}: spoiler olarak işaretli',
  'chat.composer.spoilerOff': '{name}: spoiler olarak işaretle',
  'chat.composer.retryAttachment': '{name}: tekrar yükle',
};

export default dict;
